
import { defineComponent, ref } from "vue";

export default defineComponent({
  name: "merchant-tasks",
  components: {},
  props: {
    widgetClasses: String,
  },
  setup() {
    const checked = ref(false);

    const list = [
      {
        image: "/media/avatars/300-6.jpg",
        name: "Ana Simmons",
        skills: "asimmons@gmail.com",
        companyName: "Intertico",
        companySkills: "www.landinpage1.com",
        value: "50",
        color: "bg-warning",
        alert: "alert-dismissible",
      },
      {
        image: "/media/avatars/300-6.jpg",
        name: "Ana Simmons",
        skills: "asimmons@gmail.com",
        companyName: "Intertico",
        companySkills: "www.landinpage1.com",
        value: "50",
        color: "bg-warning",
        alert: "alert-dismissible",
      },
      {
        image: "/media/avatars/300-6.jpg",
        name: "Ana Simmons",
        skills: "asimmons@gmail.com",
        companyName: "Intertico",
        companySkills: "www.landinpage1.com",
        value: "50",
        color: "bg-warning",
        alert: "alert-dismissible",
      },
      {
        image: "/media/avatars/300-2.jpg",
        name: "Jessie Clarcson",
        skills: "jclarcson@aol.com",
        companyName: "Agoda",
        companySkills: "www.landinpage3.com",
        value: "70",
        color: "bg-success text-white",
        alert: "alert",
      },
      {
        image: "/media/avatars/300-2.jpg",
        name: "Jessie Clarcson",
        skills: "jclarcson@aol.com",
        companyName: "Agoda",
        companySkills: "www.landinpage3.com",
        value: "70",
        color: "bg-success text-white",
        alert: "alert",
      },
      {
        image: "/media/avatars/300-2.jpg",
        name: "Jessie Clarcson",
        skills: "jclarcson@aol.com",
        companyName: "Agoda",
        companySkills: "www.landinpage3.com",
        value: "70",
        color: "bg-success text-white",
        alert: "alert",
      },
    ];

    return {
      list,
      checked,
    };
  },
});
